import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { useSEO } from '../../hooks/useSEO';
import SectionHeading from '../../components/ui/SectionHeading';
import AnimatedSection from '../../components/ui/AnimatedSection';
import SafeIcon from '../../common/SafeIcon';

const Services = () => {
  const { FiMap, FiCode, FiEdit3, FiZap, FiSmartphone, FiBriefcase } = FiIcons;

  useSEO({
    title: 'NYC SEO Services | Local, Technical & AI SEO Experts',
    description: 'Comprehensive SEO services in NYC including Local SEO, Technical SEO, Content Marketing, Voice Search, and Enterprise SEO Solutions.',
  });

  const servicesList = [
    { title: "Local SEO for NYC Businesses", icon: FiMap, desc: "Dominate the local map pack. We optimize your Google Business Profile, manage local citations, and create hyper-targeted neighborhood content." },
    { title: "Technical SEO", icon: FiCode, desc: "We overhaul your website's architecture, fix crawl errors, implement advanced schema markup, and ensure search engines can perfectly index your site." },
    { title: "Content Marketing & Authority", icon: FiEdit3, desc: "We produce semantic, authoritative content that establishes topical authority, earning natural backlinks and dominating long-tail NYC keywords." },
    { title: "Website Speed Optimization", icon: FiZap, desc: "Core Web Vitals are critical. We optimize code, compress assets, and configure servers to ensure blazing fast load times for mobile users on the go in NYC." },
    { title: "Mobile & Voice Search", icon: FiSmartphone, desc: "With most NYC searches happening on mobile devices, we ensure flawless responsive design and optimize for natural language voice queries." },
    { title: "Enterprise SEO Solutions", icon: FiBriefcase, desc: "Massive scale strategies for large NYC corporations involving programmatic SEO, complex site architectures, and international visibility." }
  ];

  return (
    <div className="pt-20 pb-24 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="What We Do" 
            title="Elite SEO Services for NYC Brands" 
            description="We deploy aggressive, data-backed strategies to capture market share in the most highly contested digital environment in the world."
          />
        </AnimatedSection>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {servicesList.map((srv, i) => (
            <AnimatedSection key={i} delay={i * 0.1}>
              <div className="bg-slate-900 border border-slate-800 p-8 rounded-xl h-full hover:border-purple-500/50 transition-all group">
                <SafeIcon icon={srv.icon} className="text-4xl text-purple-500 mb-6 group-hover:scale-110 transition-transform" />
                <h3 className="text-xl font-bold text-white mb-4">{srv.title}</h3>
                <p className="text-slate-400 leading-relaxed">{srv.desc}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;